import React, { Component } from 'react';
import { Icon, Grid, Typography,Card } from '@material-ui/core';
import { AddCircleOutline, RemoveCircleOutline } from '@material-ui/icons';
import {primaryColor, webFont} from "../../config/theme";
import IconButton from "@material-ui/core/IconButton";
import { parseAmountDecimal } from "../../utils/common-methods";

export default class CartDish extends Component {

  render() {
    const { dish } = this.props;
    const pricePerQty = parseFloat((dish.minPrice / dish.minDinerSize).toFixed(2));
    const price = Math.round(pricePerQty * dish.serves);

    return(

        <Grid container alignItems={'center'}>
            <Grid
            data-test-id={"cart-dishname"}
            item xs={7} style={{ paddingRight: 5 }}>
              <Typography style={{ ...styles.setFont, fontSize: 15 }}>
                {dish.name}
              </Typography>
            </Grid>
            <Grid
            data-test-id={"dish-serve"}
            item xs={3}>
              <RemoveCircleOutline
               data-test-id={"decqty"}
                  style={{ ...styles.setFont, ...styles.setColor, ...styles.setRoundedIcon, fontSize: 20, float: 'left', marginTop: 3, marginRight: 5 }}
                  onClick={() => this.props.decreaseDishQty(dish.id, dish.serves) } />


              <Typography style={{ ...styles.setFont, fontSize: 15, float: 'left', marginTop: 3}}>
                {dish.serves}
              </Typography>

              <AddCircleOutline
               data-test-id={"incqty"}
                  style={{ ...styles.setFont, ...styles.setColor, ...styles.setRoundedIcon, fontSize: 20, float: 'left', marginTop: 3, marginLeft: 5 }}
                  onClick={() => this.props.increaseDishQty(dish.id, dish.serves) } />
          </Grid>

            <Grid
            data-test-id={"dishprice"}
            item xs={2}>
              <Typography style={{ ...styles.setFont, fontSize: 15 }}>
                ${parseAmountDecimal(price)}
              </Typography>
            </Grid>
          </Grid>
    );
  }
}

const styles = {
  setFont: {
    fontFamily: webFont
  },
  setColor: {
    color: primaryColor
  },
  setRoundedIcon: {
    borderRadius: '50%',
    borderColor: primaryColor
  }
};
